import { compose } from "redux";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../../models/Action";
import { immutableSet } from "../../../../utils/immutable";
import { actionTypes } from "./actions";
import {
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./constants";
import emptyState from "./emptyState";
import { IDENTITY_SYSTEM } from "../../../../module/constants";
import { pipe } from "ramda";

const {
  APPLICATIONS,
  TOTAL_APPLICATIONS,
  SELECTED_APPLICATION,
  SELECTED_APPLICATION_CONFIGURATION,
  TEMPORARY_ABILITATIONS,
  ADDED,
  REMOVED,
  TOTAL,
  PREVIOUS,
  SELECTED_TEMPORARY_ABILITATION,
  CONFIGURATIONS,
  BASIC_CONFIGURATION,
  EMERGENCY_CONFIGURATION,
  NEW_ADDED_ROLES,
  ROLES,
  FIELDS,
  REQUEST_STATE,
  RESPONSE_MESSAGE,
  REQUEST_STATE_ROLES_CREATION,
  SYSTEM_USERS,
  EDIT_EMERGENCY_CONFIGURATION,
  GLOBAL_CATALOG,
  SELECTED_EMERGENCY_CONFIGURATION,
  EMERGENCY_ADDED_ENTITLEMENTS,
  EMERGENCY_DELETED_ENTITLEMENTS,
  EMERGENCY_TOTAL_ENTITLEMENTS,
  UPDATE_EMERGENCY_CONFIGURATION_CALL_STATE,
} = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.GET_USER_TEMPORARY_ABILITATIONS_AUTOCOMPLETE_DIGITAL_ID_SUCCESS]:
    (state: any, action: any) => {
      const mappedResponse = action.payload.map((user: any) => {
        return {
          id: user.id,
          code: user.code,
          name: user.name,
          surname: user.surname,
        };
      });
      return immutableSet([SYSTEM_USERS], mappedResponse, state);
    },
  [actionTypes.GET_USER_TEMPORARY_ABILITATIONS_AUTOCOMPLETE_DIGITAL_ID_FAILURE]:
    (state: any, action: any) => immutableSet([SYSTEM_USERS], [], state),

  [actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_APPLICATIONS_REQUEST]: (
    state: any,
    action: any
  ) => immutableSet([APPLICATIONS, LOADER_IDENTIFIER], true, state),

  [actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_APPLICATIONS_REQUEST_SUCCESS]:
    (state: any, action: any) => {
      let mappedResponse = [] as any[];
      const { applications, ...paginationData } = action.payload;
      action.payload &&
        action.payload.applications &&
        action.payload.applications.length > 0 &&
        action.payload.applications.forEach((el: any) => {
          let obj = {
            uniqueId: el.identityApplicationId,

            application: el.name,
            applicationDescription: el.description,
            identitySystemId:
              IDENTITY_SYSTEM[
                el.identitySystemId as keyof typeof IDENTITY_SYSTEM
              ],
          };
          mappedResponse.push(obj);
        });
      let modifiedPayload = {
        ...paginationData,
        applications: mappedResponse,
      };
      return compose(
        immutableSet([APPLICATIONS, TOTAL_APPLICATIONS], action.payload),
        immutableSet([APPLICATIONS, LIST_IDENTIFIER], modifiedPayload),
        immutableSet([APPLICATIONS, LOADER_IDENTIFIER], false)
      )(state);
    },

  [actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_APPLICATIONS_REQUEST_FAILURE]:
    (state: any, action: any) =>
      immutableSet([APPLICATIONS, LOADER_IDENTIFIER], false, state),

  [actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_GET_SELECTED_APPLICATION_CONFIGURATION_REQUEST]:
    (state: any, action: any) =>
      immutableSet(
        [APPLICATIONS, SELECTED_APPLICATION_CONFIGURATION],
        {},
        state
      ),

  [actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_GET_SELECTED_APPLICATION_CONFIGURATION_REQUEST_SUCCESS]:
    (state: any, action: any) =>
      immutableSet(
        [APPLICATIONS, SELECTED_APPLICATION_CONFIGURATION],
        action.payload,
        state
      ),

  [actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_GET_SELECTED_APPLICATION_CONFIGURATION_REQUEST_FAILURE]:
    (state: any, action: any) =>
      immutableSet(
        [APPLICATIONS, SELECTED_APPLICATION_CONFIGURATION],
        {},
        state
      ),

  [actionTypes.CREATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST]:
    (state: any, action: any) =>
      immutableSet([REQUEST_STATE], IResponseState.PENDING, state),

  [actionTypes.CREATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_SUCCESS]:
    (state: any, action: any) =>
      immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),

  [actionTypes.CREATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_FAILURE]:
    (state: any, action: any) =>
      immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.UPDATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST]:
    (state: any, action: any) =>
      immutableSet([REQUEST_STATE], IResponseState.PENDING, state),

  [actionTypes.UPDATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_SUCCESS]:
    (state: any, action: any) =>
      immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),

  [actionTypes.UPDATE_CONFIGURATION_APPLICATION_TEMPORARY_ABILITATIONS_MGMT_REQUEST_FAILURE]:
    (state: any, action: any) =>
      immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.GET_TEMPORARY_ABILITATIONS_ALREADY_SET_ON_APPLICATION_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [APPLICATIONS, TEMPORARY_ABILITATIONS, PREVIOUS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.GET_TEMPORARY_ABILITATIONS_ALREADY_SET_ON_APPLICATION_REQUEST_SUCCESS]:
    (state: any, action: any) => {
      let mappedResponse = [] as any[];
      let selectedApplicationName = [
        state.applications.selectedApplication.name,
      ];
      let selectedApplicationId = [
        state.applications.selectedApplication.identityApplicationId,
      ];
      if (
        action.payload &&
        action.payload.entitlements &&
        action.payload.entitlements.length > 0
      ) {
        action.payload.entitlements.forEach((entitlement: any) => {
          if (entitlement.applicationName === selectedApplicationName[0]) {
            let obj = {
              entitlement_id: entitlement.entitlementId,
              identity_system_id: entitlement.identitySystemId,
              entitlement_name: entitlement.entitlementName,
              entitlement_description: entitlement.entitlementDescription,
              application_id: selectedApplicationId[0],
              application_name: entitlement.applicationName,
              application_description: entitlement.applicationDescription,
              identitySystemId:
                IDENTITY_SYSTEM[
                  entitlement.identitySystemId as keyof typeof IDENTITY_SYSTEM
                ],
            };
            mappedResponse.push(obj);
          }
        });
      }
      return compose(
        immutableSet(
          [APPLICATIONS, TEMPORARY_ABILITATIONS, PREVIOUS, LIST_IDENTIFIER],
          mappedResponse
        ),
        immutableSet(
          [APPLICATIONS, TEMPORARY_ABILITATIONS, PREVIOUS, LOADER_IDENTIFIER],
          false
        ),
        immutableSet(
          [APPLICATIONS, TEMPORARY_ABILITATIONS, TOTAL],
          mappedResponse
        )
      )(state);
    },

  [actionTypes.GET_TEMPORARY_ABILITATIONS_ALREADY_SET_ON_APPLICATION_REQUEST_FAILURE]:
    (state: any, action: any) =>
      immutableSet(
        [APPLICATIONS, TEMPORARY_ABILITATIONS, PREVIOUS, LOADER_IDENTIFIER],
        false,
        state
      ),

  [actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_ABILITATIONS_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [APPLICATIONS, TEMPORARY_ABILITATIONS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_ABILITATIONS_REQUEST_SUCCESS]:
    (state: any, action: any) => {
      const { entitlements, ...paginationData } = action.payload;
      let mappedResponse = [] as any[];
      entitlements.forEach((entitlement: any) => {
        const tempEntitlement = {
          ...entitlement,
          identitySystemId:
            IDENTITY_SYSTEM[
              entitlement.identity_system_id as keyof typeof IDENTITY_SYSTEM
            ],
        };
        mappedResponse.push(tempEntitlement);
      });
      let total = [...state.applications.temporaryAbilitations.total];
      return compose(
        immutableSet([APPLICATIONS, TEMPORARY_ABILITATIONS, LIST_IDENTIFIER], {
          entitlements: mappedResponse,
          ...paginationData,
        }),
        immutableSet(
          [APPLICATIONS, TEMPORARY_ABILITATIONS, LOADER_IDENTIFIER],
          false
        ),
        immutableSet([APPLICATIONS, TEMPORARY_ABILITATIONS, TOTAL], total)
      )(state);
    },

  [actionTypes.TEMPORARY_ABILITATIONS_MANAGEMENT_FETCH_ABILITATIONS_REQUEST_FAILURE]:
    (state: any, action: any) =>
      immutableSet(
        [APPLICATIONS, TEMPORARY_ABILITATIONS, LOADER_IDENTIFIER],
        false,
        state
      ),

  [actionTypes.SET_SELECTED_APPLICATION_TEMPORARY_ABILITATIONS_MANAGEMENT]: (
    state: any,
    action: any
  ) => immutableSet([APPLICATIONS, SELECTED_APPLICATION], action.row, state),

  [actionTypes.MODIFY_ADDED_TEMPORARY_ABILITATIONS_CONSOLE_ADMIN]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [APPLICATIONS, TEMPORARY_ABILITATIONS, ADDED],
      action.payload,
      state
    ),

  [actionTypes.MODIFY_DELETED_TEMPORARY_ABILITATIONS_CONSOLE_ADMIN]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [APPLICATIONS, TEMPORARY_ABILITATIONS, REMOVED],
      action.payload,
      state
    ),

  [actionTypes.MODIFY_TOTAL_TEMPORARY_ABILITATIONS_CONSOLE_ADMIN]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [APPLICATIONS, TEMPORARY_ABILITATIONS, TOTAL],
      action.payload,
      state
    ),

  [actionTypes.FETCH_TEMPORARY_ENTITLEMENTS_REQUEST]: (
    state: any,
    action: any
  ) => immutableSet([TEMPORARY_ABILITATIONS, LOADER_IDENTIFIER], true, state),

  [actionTypes.FETCH_TEMPORARY_ENTITLEMENTS_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const { entitlements, ...paginationData } = action.payload;
    const mappedResponse: any[] = [];
    entitlements &&
      entitlements.length > 0 &&
      entitlements.forEach((entitlement: any) => {
        mappedResponse.push({
          ...entitlement,
          identitySystemId:
            IDENTITY_SYSTEM[
              entitlement.identitySystemId as keyof typeof IDENTITY_SYSTEM
            ],
        });
      });
    return compose(
      immutableSet([TEMPORARY_ABILITATIONS, LIST_IDENTIFIER], {
        entitlements: mappedResponse,
        ...paginationData,
      }),
      immutableSet([TEMPORARY_ABILITATIONS, LOADER_IDENTIFIER], false)
    )(state);
  },

  [actionTypes.FETCH_TEMPORARY_ENTITLEMENTS_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([TEMPORARY_ABILITATIONS, LOADER_IDENTIFIER], false, state),

  [actionTypes.FETCH_GET_ROLES_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [TEMPORARY_ABILITATIONS, ROLES, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.FETCH_GET_ROLES_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST_SUCCESS]:
    (state: any, action: any) => {
      let mappedResponse = [] as any[];
      if (
        action.payload &&
        action.payload.roles &&
        action.payload.roles.length > 0
      ) {
        for (var i = 0; i < action.payload.roles.length; i++) {
          let obj = {
            id: i,
            role: action.payload.roles[i],
          };
          mappedResponse.push(obj);
        }
      }
      return compose(
        immutableSet(
          [TEMPORARY_ABILITATIONS, ROLES, LIST_IDENTIFIER],
          mappedResponse
        ),
        immutableSet([TEMPORARY_ABILITATIONS, ROLES, LOADER_IDENTIFIER], false)
      )(state);
    },

  [actionTypes.FETCH_GET_ROLES_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST_FAILURE]:
    (state: any, action: any) =>
      immutableSet(
        [TEMPORARY_ABILITATIONS, ROLES, LOADER_IDENTIFIER],
        false,
        state
      ),

  [actionTypes.CREATE_ROLE_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [TEMPORARY_ABILITATIONS, ROLES, REQUEST_STATE_ROLES_CREATION],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.CREATE_ROLE_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_SUCCESS]:
    (state: any, action: any) =>
      immutableSet(
        [TEMPORARY_ABILITATIONS, ROLES, REQUEST_STATE_ROLES_CREATION],
        IResponseState.SUCCESS,
        state
      ),

  [actionTypes.CREATE_ROLE_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_FAILURE]:
    (state: any, action: any) =>
      immutableSet(
        [TEMPORARY_ABILITATIONS, ROLES, REQUEST_STATE_ROLES_CREATION],
        IResponseState.ERROR,
        state
      ),

  [actionTypes.ADD_NEW_ROLE_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [TEMPORARY_ABILITATIONS, ROLES, NEW_ADDED_ROLES],
      action.payload,
      state
    ),

  [actionTypes.REMOVE_NEW_ROLE_TEMPORARY_ENTITLEMENTS_CONFIGURATION_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [TEMPORARY_ABILITATIONS, ROLES, NEW_ADDED_ROLES],
      action.payload,
      state
    ),

  [actionTypes.SET_SELECTED_TEMPORARY_ENTITLEMENT_TEMPORARY_ABILITATIONS_MANAGEMENT]:
    (state: any, action: any) =>
      immutableSet(
        [TEMPORARY_ABILITATIONS, SELECTED_TEMPORARY_ABILITATION],
        action.row,
        state
      ),

  [actionTypes.MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST]: (
    state: any,
    action: any
  ) => immutableSet([REQUEST_STATE], IResponseState.PENDING, state),

  [actionTypes.MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST_SUCCESS]:
    (state: any, action: any) =>
      pipe(
        (s) => immutableSet([REQUEST_STATE], IResponseState.SUCCESS, s),
        (s) => immutableSet([RESPONSE_MESSAGE], action.payload.message, s)
      )(state),

  [actionTypes.MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST_WARNING]:
    (state: any, action: any) =>
      pipe(
        (s) => immutableSet([REQUEST_STATE], IResponseState.WARNING, s),
        (s) => immutableSet([RESPONSE_MESSAGE], action.payload.message, s)
      )(state),

  [actionTypes.MANAGE_TEMPORARY_ABILITATIONS_IN_SELECTED_APPLICATION_REQUEST_FAILURE]:
    (state: any, action: any) =>
      immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.RESET_TEMPORARY_ABILITATIONS_IN_APPLICATION_CONFIGURATION]: (
    state: any,
    action: any
  ) =>
    compose(
      immutableSet([APPLICATIONS, TEMPORARY_ABILITATIONS, LIST_IDENTIFIER], []),
      immutableSet(
        [APPLICATIONS, TEMPORARY_ABILITATIONS, LOADER_IDENTIFIER],
        false
      ),
      immutableSet(
        [APPLICATIONS, TEMPORARY_ABILITATIONS, PREVIOUS, LIST_IDENTIFIER],
        []
      ),
      immutableSet([APPLICATIONS, TEMPORARY_ABILITATIONS, TOTAL], []),
      immutableSet([APPLICATIONS, TEMPORARY_ABILITATIONS, ADDED], []),
      immutableSet([APPLICATIONS, TEMPORARY_ABILITATIONS, REMOVED], [])
    )(state),

  [actionTypes.FETCH_GET_TEMPORARY_ENTITLEMENT_CONFIGURATIONS_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [TEMPORARY_ABILITATIONS, CONFIGURATIONS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.FETCH_GET_TEMPORARY_ENTITLEMENT_CONFIGURATIONS_REQUEST_SUCCESS]:
    (state: any, action: any) => {
      let basicConfigs = [] as any[];
      let emergencyConfigs = [] as any[];
      action.payload &&
        action.payload.length > 0 &&
        action.payload.forEach((config: any) => {
          let currentConfig = {
            ...config,
            uniqueId: config.id,
            identitySystemId:
              IDENTITY_SYSTEM[
                config.identitySystemId as keyof typeof IDENTITY_SYSTEM
              ],
          };
          delete currentConfig.id;
          if (currentConfig.emergencyName) {
            emergencyConfigs.push(currentConfig);
          } else {
            basicConfigs.push(currentConfig);
          }
        });

      return compose(
        immutableSet(
          [TEMPORARY_ABILITATIONS, CONFIGURATIONS, BASIC_CONFIGURATION],
          basicConfigs
        ),
        immutableSet(
          [TEMPORARY_ABILITATIONS, CONFIGURATIONS, EMERGENCY_CONFIGURATION],
          emergencyConfigs
        ),
        immutableSet(
          [TEMPORARY_ABILITATIONS, CONFIGURATIONS, LOADER_IDENTIFIER],
          false
        )
      )(state);
    },

  [actionTypes.FETCH_GET_TEMPORARY_ENTITLEMENT_CONFIGURATIONS_REQUEST_FAILURE]:
    (state: any, action: any) => {
      return compose(
        immutableSet(
          [TEMPORARY_ABILITATIONS, CONFIGURATIONS, BASIC_CONFIGURATION],
          []
        ),
        immutableSet(
          [TEMPORARY_ABILITATIONS, CONFIGURATIONS, EMERGENCY_CONFIGURATION],
          []
        ),
        immutableSet(
          [TEMPORARY_ABILITATIONS, CONFIGURATIONS, LOADER_IDENTIFIER],
          false
        )
      )(state);
    },

  [actionTypes.CREATE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST]: (
    state: any,
    action: any
  ) => immutableSet([REQUEST_STATE], IResponseState.PENDING, state),

  [actionTypes.CREATE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),

  [actionTypes.CREATE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.DELETE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST]: (
    state: any,
    action: any
  ) => immutableSet([REQUEST_STATE], IResponseState.PENDING, state),

  [actionTypes.DELETE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),

  [actionTypes.DELETE_TEMPORARY_ENTITLEMENT_CONFIGURATION_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.GET_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [TEMPORARY_ABILITATIONS, FIELDS, LOADER_IDENTIFIER],
      true,
      state
    ),

  [actionTypes.GET_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_SUCCESS]:
    (state: any, action: any) => {
      let mappedResponse = [] as any[];
      if (
        action.payload &&
        action.payload.fields &&
        action.payload.fields.length > 0
      ) {
        action.payload.fields.forEach((field: string) =>
          mappedResponse.push({ uniqueId: field, field: field })
        );
      }
      return compose(
        immutableSet(
          [TEMPORARY_ABILITATIONS, FIELDS, LIST_IDENTIFIER],
          mappedResponse
        ),
        immutableSet([TEMPORARY_ABILITATIONS, FIELDS, LOADER_IDENTIFIER], false)
      )(state);
    },

  [actionTypes.GET_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_FAILURE]:
    (state: any, action: any) =>
      immutableSet(
        [TEMPORARY_ABILITATIONS, FIELDS, LOADER_IDENTIFIER],
        false,
        state
      ),

  [actionTypes.FETCH_EMERGENCY_ENTITLEMENT_REQUIRED]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        TEMPORARY_ABILITATIONS,
        EDIT_EMERGENCY_CONFIGURATION,
        EMERGENCY_TOTAL_ENTITLEMENTS,
      ],
      [],
      state
    ),
  [actionTypes.FETCH_EMERGENCY_ENTITLEMENT_REQUIRED_SUCCESS]: (
    state: any,
    action: any
  ) => {
    const mappedResponse = [...action.payload].map((ent) => {
      return {
        ...ent,
        identitySystemId:
          IDENTITY_SYSTEM[
            ent.identity_system_id as keyof typeof IDENTITY_SYSTEM
          ],
      };
    });
    return immutableSet(
      [
        TEMPORARY_ABILITATIONS,
        EDIT_EMERGENCY_CONFIGURATION,
        EMERGENCY_TOTAL_ENTITLEMENTS,
      ],
      mappedResponse,
      state
    );
  },
  [actionTypes.FETCH_EMERGENCY_ENTITLEMENT_REQUIRED_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        TEMPORARY_ABILITATIONS,
        EDIT_EMERGENCY_CONFIGURATION,
        EMERGENCY_TOTAL_ENTITLEMENTS,
      ],
      [],
      state
    ),
  [actionTypes.FETCH_EMERGENCY_ENTITLEMENT_GLOBAL_CATALOG]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        TEMPORARY_ABILITATIONS,
        EDIT_EMERGENCY_CONFIGURATION,
        GLOBAL_CATALOG,
        LOADER_IDENTIFIER,
      ],
      true,
      state
    ),
  [actionTypes.FETCH_EMERGENCY_ENTITLEMENT_GLOBAL_CATALOG_SUCCESS]: (
    state: any,
    action: any
  ) => {
    let mappedResponse: any[] = [];
    action.payload.length > 0 &&
      action.payload.forEach((data: any) => {
        if (Array.isArray(data)) {
          const tempRow: {} = {
            entitlement_id: data[0].codeBusinessRole,
            application_name: data[0].name,
            application_description: data[0].description,
            entitlement_name: "",
            entitlement_description: "",
          };
          mappedResponse.push(tempRow);
        } else {
          const tempRow: {} = {
            entitlement_id: data.entitlement_id,
            application_name: data.application_name,
            application_description: data.application_description,
            entitlement_name: data.entitlement_name,
            entitlement_description: data.entitlement_description,
            editable: data.editable,
            deleted: false,
            added: false,
            validable: data.validable,
            chainEntitlementsIds: data.chainEntitlementsIds,
            identitySystemId:
              IDENTITY_SYSTEM[
                data.identity_system_id as keyof typeof IDENTITY_SYSTEM
              ],
          };
          mappedResponse.push(tempRow);
        }
      });
    return compose(
      immutableSet(
        [
          TEMPORARY_ABILITATIONS,
          EDIT_EMERGENCY_CONFIGURATION,
          GLOBAL_CATALOG,
          LOADER_IDENTIFIER,
        ],
        false
      ),
      immutableSet(
        [
          TEMPORARY_ABILITATIONS,
          EDIT_EMERGENCY_CONFIGURATION,
          GLOBAL_CATALOG,
          LIST_IDENTIFIER,
        ],
        mappedResponse
      )
    )(state);
  },
  [actionTypes.FETCH_EMERGENCY_ENTITLEMENT_GLOBAL_CATALOG_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet(
        [
          TEMPORARY_ABILITATIONS,
          EDIT_EMERGENCY_CONFIGURATION,
          GLOBAL_CATALOG,
          LOADER_IDENTIFIER,
        ],
        false
      ),
      immutableSet(
        [
          TEMPORARY_ABILITATIONS,
          EDIT_EMERGENCY_CONFIGURATION,
          GLOBAL_CATALOG,
          LIST_IDENTIFIER,
        ],
        []
      )
    )(state);
  },

  [actionTypes.MODIFY_EMERGENCY_ADDED_ENTITLEMENTS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        TEMPORARY_ABILITATIONS,
        EDIT_EMERGENCY_CONFIGURATION,
        EMERGENCY_ADDED_ENTITLEMENTS,
      ],
      action.payload,
      state
    ),

  [actionTypes.MODIFY_EMERGENCY_DELETED_ENTITLEMENTS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        TEMPORARY_ABILITATIONS,
        EDIT_EMERGENCY_CONFIGURATION,
        EMERGENCY_DELETED_ENTITLEMENTS,
      ],
      action.payload,
      state
    ),

  [actionTypes.MODIFY_EMERGENCY_TOTAL_ENTITLEMENTS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        TEMPORARY_ABILITATIONS,
        EDIT_EMERGENCY_CONFIGURATION,
        EMERGENCY_TOTAL_ENTITLEMENTS,
      ],
      action.payload,
      state
    ),

  [actionTypes.UPDATE_TEMPORARY_ENTITLEMENTS_REQUEST]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        TEMPORARY_ABILITATIONS,
        EDIT_EMERGENCY_CONFIGURATION,
        UPDATE_EMERGENCY_CONFIGURATION_CALL_STATE,
      ],
      IResponseState.PENDING,
      state
    ),

  [actionTypes.UPDATE_TEMPORARY_ENTITLEMENTS_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        TEMPORARY_ABILITATIONS,
        EDIT_EMERGENCY_CONFIGURATION,
        UPDATE_EMERGENCY_CONFIGURATION_CALL_STATE,
      ],
      IResponseState.SUCCESS,
      state
    ),

  [actionTypes.UPDATE_TEMPORARY_ENTITLEMENTS_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) =>
    immutableSet(
      [
        TEMPORARY_ABILITATIONS,
        EDIT_EMERGENCY_CONFIGURATION,
        UPDATE_EMERGENCY_CONFIGURATION_CALL_STATE,
      ],
      IResponseState.ERROR,
      state
    ),

  [actionTypes.UPDATE_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST]: (
    state: any,
    action: any
  ) => immutableSet([REQUEST_STATE], IResponseState.PENDING, state),

  [actionTypes.UPDATE_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_SUCCESS]:
    (state: any, action: any) =>
      immutableSet([REQUEST_STATE], IResponseState.SUCCESS, state),

  [actionTypes.UPDATE_FIELDS_TEMPORARY_ABILITATION_CONFIGURATION_REQUEST_FAILURE]:
    (state: any, action: any) =>
      immutableSet([REQUEST_STATE], IResponseState.ERROR, state),

  [actionTypes.RESET_EMERGENCY_ENTITLEMENTS_STATE]: (state: any, action: any) =>
    compose(
      immutableSet(
        [
          TEMPORARY_ABILITATIONS,
          EDIT_EMERGENCY_CONFIGURATION,
          EMERGENCY_ADDED_ENTITLEMENTS,
        ],
        []
      ),
      immutableSet(
        [
          TEMPORARY_ABILITATIONS,
          EDIT_EMERGENCY_CONFIGURATION,
          EMERGENCY_DELETED_ENTITLEMENTS,
        ],
        []
      ),
      immutableSet(
        [
          TEMPORARY_ABILITATIONS,
          EDIT_EMERGENCY_CONFIGURATION,
          EMERGENCY_TOTAL_ENTITLEMENTS,
        ],
        []
      )
    )(state),

  [actionTypes.SELECT_EMERGENCY_CONFIGURATION]: (state: any, action: any) =>
    immutableSet(
      [
        TEMPORARY_ABILITATIONS,
        EDIT_EMERGENCY_CONFIGURATION,
        SELECTED_EMERGENCY_CONFIGURATION,
      ],
      action.payload,
      state
    ),

  [actionTypes.RESET_STATE_TEMPORARY_ABILITATIONS_MANAGEMENT]: (
    state: any,
    action: any
  ) => emptyState,
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
